export function sortVals(aVal, bVal, desc) {
  let sortOrderModifier = 1;

  if (desc) {
    sortOrderModifier = -1;
  }

  if (!aVal && aVal !== 0) {
    return sortOrderModifier;
  }

  if (!bVal && bVal !== 0) {
    return -1 * sortOrderModifier;
  }

  if (aVal > bVal) return 1;
  if (aVal < bVal) return -1;

  return 0;
}

export function sortModelValues(rowA, rowB, id, desc) {
  let sortOrderModifier = 1;
  if (desc) {
    sortOrderModifier = -1;
  }

  if (rowA.values[id] === "-") {
    return sortOrderModifier;
  }

  if (rowB.values[id] === "-") {
    return -1 * sortOrderModifier;
  }

  let rowAVal = rowA.values[id];
  let rowBVal = rowB.values[id];

  const rowAFloat = parseFloat(rowAVal);

  if (!isNaN(rowAFloat)) {
    rowAVal = rowAFloat;
  }

  const rowBFloat = parseFloat(rowBVal);

  if (!isNaN(rowBFloat)) {
    rowBVal = rowBFloat;
  }

  return sortVals(rowAVal, rowBVal, desc);
}

export function sortGolfLeaderboardPositions(rowA, rowB, id, desc) {
  let rowAPos = rowA.values[id].replace("T", "");
  let rowBPos = rowB.values[id].replace("T", "");

  // This is set this way because it just works *shrug*
  let descModifier = desc ? -1 : 1;

  if (rowAPos === "MC") {
    rowAPos = 5000 * descModifier;
  } else if (rowAPos === "WD") {
    rowAPos = 10000 * descModifier;
  } else {
    rowAPos = parseInt(rowAPos);
  }

  if (rowBPos === "MC") {
    rowBPos = 5000 * descModifier;
  } else if (rowBPos === "WD") {
    rowBPos = 10000 * descModifier;
  } else {
    rowBPos = parseInt(rowBPos);
  }

  return sortVals(rowAPos, rowBPos, desc);
}

export function sortGolfToPars(rowA, rowB, id, desc) {
  let rowAToPar = rowA.values[id];

  if (rowAToPar) {
    rowAToPar = rowAToPar.replace("+", "");
  } else {
    // Default to WD if value is null
    rowAToPar = "WD";
  }

  let rowBToPar = rowB.values[id];

  if (rowBToPar) {
    rowBToPar = rowBToPar.replace("+", "");
  } else {
    // Default to WD if value is null
    rowBToPar = "WD";
  }

  let descModifier = desc ? 1 : -1;

  if (rowAToPar === "E") {
    rowAToPar = 0;
  } else if (rowAToPar === "MC") {
    rowAToPar = 5000 * descModifier;
  } else if (rowAToPar === "WD") {
    rowAToPar = 10000 * descModifier;
  } else {
    rowAToPar = parseInt(rowAToPar);
  }

  if (rowBToPar === "E") {
    rowBToPar = 0;
  } else if (rowBToPar === "MC") {
    rowBToPar = 5000 * descModifier;
  } else if (rowBToPar === "WD") {
    rowBToPar = 10000 * descModifier;
  } else {
    rowBToPar = parseInt(rowBToPar);
  }

  return sortVals(rowAToPar, rowBToPar, desc);
}

export function sortPercentageFloat(rowA, rowB, id, desc) {
  const rowAVal = parseFloat(rowA.values[id].replace("%", ""));
  const rowBVal = parseFloat(rowB.values[id].replace("%", ""));

  return sortVals(rowAVal, rowBVal, desc);
}

export function sortFloats(rowA, rowB, id, desc) {
  const rowAVal = parseFloat(rowA.values[id]);
  const rowBVal = parseFloat(rowB.values[id]);

  return sortVals(rowAVal, rowBVal, desc);
}

export function updateLocalMinMaxVal(obj, key, value) {
  if (!(key in obj)) {
    obj[key] = {
      min: Number.MAX_SAFE_INTEGER,
      max: Number.MIN_SAFE_INTEGER,
    };
  }

  if (value > obj[key]["max"]) {
    obj[key]["max"] = value;
  }

  if (value < obj[key]["min"]) {
    obj[key]["min"] = value;
  }
}

export function getColorGradientValue(minMaxVals, key, value, highStatIsGood) {
  if (!minMaxVals || !(key in minMaxVals)) {
    return null;
  }

  const columnMin = minMaxVals[key]["min"];
  const columnMax = minMaxVals[key]["max"];
  const columnDiff = columnMax - columnMin;
  const valueNormalized = (value - columnMin) / columnDiff;

  return colorGradient(valueNormalized, highStatIsGood);
}

export function colorGradient(fadeFraction, highStatIsGood = true) {
  const rgbColorGreen = {
    red: 153,
    green: 227,
    blue: 221,
  };
  const rgbColorYellow = {
    red: 250,
    green: 233,
    blue: 159,
  };
  const rgbColorRed = {
    red: 254,
    green: 192,
    blue: 191,
  };

  let color1, color2;

  if (highStatIsGood) {
    color1 = rgbColorRed;
    color2 = rgbColorYellow;
  } else {
    color1 = rgbColorGreen;
    color2 = rgbColorYellow;
  }

  let fade = fadeFraction;

  fade = fade * 2;

  // Find which interval to use and adjust the fade percentage
  if (fade >= 1) {
    fade -= 1;

    if (highStatIsGood) {
      color1 = rgbColorYellow;
      color2 = rgbColorGreen;
    } else {
      color1 = rgbColorYellow;
      color2 = rgbColorRed;
    }
  }

  let diffRed = color2.red - color1.red;
  let diffGreen = color2.green - color1.green;
  let diffBlue = color2.blue - color1.blue;

  let gradient = {
    red: parseInt(Math.floor(color1.red + diffRed * fade), 10),
    green: parseInt(Math.floor(color1.green + diffGreen * fade), 10),
    blue: parseInt(Math.floor(color1.blue + diffBlue * fade), 10),
  };

  return (
    "rgb(" + gradient.red + "," + gradient.green + "," + gradient.blue + ")"
  );
}
